var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.334473,
    width: 40,
    height: 40,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0574 13.8887H21.1575C22.0823 13.892 26.7679 13.9258 28.0312 14.2655C28.4132 14.3692 28.7612 14.5713 29.0406 14.8517C29.3199 15.132 29.5208 15.4808 29.6231 15.863C29.7367 16.2905 29.8166 16.8564 29.8706 17.4403L29.8819 17.5573L29.9066 17.8498L29.9156 17.9668C29.9888 18.995 29.9977 19.958 29.9989 20.1684V20.2528C29.9977 20.471 29.9876 21.4993 29.9066 22.5703L29.8976 22.6884L29.8875 22.8054C29.8312 23.4489 29.748 24.0879 29.6231 24.5582C29.5208 24.9405 29.3199 25.2892 29.0406 25.5695C28.7612 25.8499 28.4132 26.052 28.0312 26.1557C26.7262 26.5067 21.7661 26.5314 21.0787 26.5325H20.919C20.5714 26.5325 19.1336 26.5258 17.6261 26.474L17.4349 26.4673L17.337 26.4628L17.1446 26.4549L16.9523 26.447C15.7035 26.3919 14.5144 26.303 13.9665 26.1545C13.5847 26.051 13.2368 25.849 12.9574 25.5689C12.6781 25.2888 12.4771 24.9403 12.3746 24.5582C12.2498 24.089 12.1665 23.4489 12.1102 22.8054L12.1013 22.6873L12.0923 22.5703C12.0364 21.808 12.0056 21.0441 12 20.2798L12 20.1414C12.0023 19.8995 12.0113 19.0637 12.072 18.1412L12.0799 18.0253L12.0833 17.9668L12.0923 17.8498L12.117 17.5573L12.1283 17.4403C12.1822 16.8564 12.2621 16.2894 12.3758 15.863C12.4781 15.4808 12.679 15.132 12.9583 14.8517C13.2377 14.5713 13.5857 14.3692 13.9676 14.2655C14.5155 14.1193 15.7046 14.0293 16.9534 13.973L17.1446 13.9652L17.3381 13.9584L17.4349 13.955L17.6272 13.9472C18.6979 13.9128 19.769 13.8936 20.8403 13.8898L21.0574 13.8887ZM19.2 17.4999V22.9202L23.8766 20.2112L19.2 17.4999Z",
    fill: "#004B7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8b842b6451ed09c9f6f8a2468575ad46.svg";
export { ForwardRef as ReactComponent };